import { InputMask } from "@react-input/mask";
import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";
import Loading from "@/atomic/atoms/Loading";
import environment from "@/settings/environment";

export default function VehiclesView({
  goBack,
  change,
  plate,
  onChange,
  isLoading,
  isVisibleModal,
  error,
  toggleModal,
  handleKeyDown,
  isDisabled,
}: PropsView) {
  const renderModal = () => (
    <div className="fixed flex flex-1 top-0 left-0 right-0 bottom-0 z-20 w-full bg-black/30 justify-center items-start text-black h-full min-h-screen">
      <div className="relative w-full max-w-[calc(480px)] max-h-full mt-[calc(100px)]">
        <div className="relative bg-white rounded-2xl shadow p-5">
         <div className="w-full flex flex-col items-center pb-3">
            <p className="self-center text-lg mt-3 font-bold mb-3">Atenção!</p>
            <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
            <p className="text-sm mt-2 text-center">{error ? "Não foi trocar sua placa. Tente novamente." : "Essa placa já possui um meio de pagamento automático cadastrado, sua cobrança é automática e não é preciso buscar débitos no Pedágio Eletrônico Sem Parar."}</p>
            <button type="button" onClick={toggleModal} className="mt-3 mb-3 bg-black border p-2 rounded-lg h-[calc(60px)] text-white w-full">Fechar</button>
          </div>
        </div>
      </div>
    </div>
  );
  return (
    <div className="h-full">
      <Header
        title="Dados do veículo"
        goBack={goBack}
        hasLeftButton
      />
      <main className="p-2 w-full flex justify-center h-[calc(100%-72px)] text-black h-form bg-white">
        <form className="h-full flex flex-col justify-between w-[calc(480px)]" onSubmit={change}>
          <div className="w-full">
            <h2 className="text-black text-lg">Digite a placa desejada</h2>
            <InputMask 
              value={plate}
              name="plate"
              required 
              onChange={onChange} 
              onKeyDown={handleKeyDown}
              type="text"
              mask="___-.@.." 
              replacement={{ _: /\D/, ".": /\d/, "@": /[A-Za-z0-9]*/ }} 
              placeholder="Placa"
              className="uppercase mt-3 text-base text-black w-full bg-transparent border p-2 rounded-lg h-14"
            />
            <div className="w-full my-4 p-4">
              <div
                className="g-recaptcha mx-auto"
                data-sitekey={environment.recaptcha.siteKey}
                data-size="normal"
                data-theme="light"
                data-callback="onRecaptchaVerify"
                data-expired-callback="onRecaptchaExpired"
                data-error-callback="onRecaptchaError"
              />
            </div>
          </div>
          <button 
            className={`mb-[calc(80px)] ${isDisabled ? "bg-gray-300 text-white" : "bg-black text-white"} border p-2 rounded-lg h-[calc(60px)] w-full`}
            type="submit"
            disabled={isDisabled}>
            Trocar
          </button>
        </form>
      </main>
      {isVisibleModal && renderModal()}
      {isLoading && <Loading />}
    </div>
  );
}